/**
* @Author: wulizhou
* @Description: 需求详情分享按钮组 包含 微博 小红书 复制链接
* @Date:  2023.4.20
**/

<template>
  <div class="ShareByDemandPoolDetail">
    <div
      v-for="vo in list"
      :key="vo.id"
      class="channel-item"
      :class="[ 'channel-item' + vo.id , { 'Copy': vo.id == 5 } ]"
      @click="handleClick(vo)"
    >
      <i :class="['iconfont', vo.iconClass]"/>
      <div
        class="qr-code">
        <img :src="CON_COMMON.CON_BASIC.BASE_IMG_UPLOAD + vo.qrCodeImg">
        <div class="desc">{{ vo.qrCodeDesc }}</div>
      </div>
    </div>

  </div>
</template>

<script>

/* 引入公共方法和常量 */
import * as fnCommon from '@/fn/_fn';
import * as CON_COMMON from '@/constant/_constant';

/* 引入组件 */

/* 引入VUEX */
import {mapState} from "vuex";

/* 引入API */

export default {
  name: "ShareByDemandPoolDetail"

  , components: {}

  , props: {
    shareType: {
      type: String,
      default: '1-2-3'
    },
    list: {
      type: Array,
      default: () => []
    }
  }

  , watch: {}

  , computed: {}

  , data() {
    return {
      CON_COMMON
    }
  }

  , methods: {
    toggleShowQrCode(vo, flag = true) {
      vo.isShow = flag
      console.log(vo)
      // let index = this.list.findIndex(item => vo.id == item.id)
      // this.$set(this.list, index, vo)

      this.$set(vo, 'isShow', vo.isShow)
    }
    , handleClick(item) {
      if (item.id == 1) {
        this.$emit('shareWb')
      } else if (item.id == 4) {
        this.$emit('shareXhs')
      } else if (item.id == 5) {
        this.$emit('copyLink')
      }
    }
  }

}
</script>

<style lang="scss" scoped>

.ShareByDemandPoolDetail {
  display: flex;

  .share-item {
    width: 34px;
    height: 34px;
    background: #F5F6FA;
    border-radius: 50%;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:last-child {
      margin-right: 0;
    }

    .iconfont {
      color: #BFC2D2;
    }

    .icon-weibo2 {
      font-size: 16px;
    }

    &.wb {
      width: 34px;
    }

    &.xhs {
      width: 50px;
      border-radius: 17px;
    }

    &.share {

    }

  }

}


.channel-item {
  position: relative;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  width: 34px;
  height: 34px;
  background: #F5F6FA;

  &.channel-item4 {
    width: 50px;
    border-radius: 17px;
  }

  &.icon_weibo {

  }

  &.icon_xhs {
    width: 50px;
    height: 34px;
    background: #F5F6FA;
    border-radius: 17px;
  }


  &:hover {
    .qr-code {
      display: flex;
    }
  }

  &.channel-item5 {
    &:hover {
      .qr-code {
        display: none;
      }
    }
  }


}

.iconfont {
  color: #BFC2D2;
  cursor: pointer;

  @mixin EleHover($bg-color) {
    &:hover {
      color: $bg-color;
    }
  }

  &.icon-weibo21 {
    @include EleHover(#FF5E61);
  }

  &.icon-xhs21 {
    @include EleHover(#FE2842);
  }

  &.icon_weixin {
    @include EleHover(rgba(81, 207, 80, 1));
  }

  &.icon-copylink {
    @include EleHover(rgba(105, 105, 255, 1));
  }

}

.qr-code {
  width: 162px;
  background: #FFFFFF;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
  @include Position(1, 5, 50%, 45px);
  transform: translateX(-50%);
  padding: 16px 0 16px;
  box-sizing: border-box;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  display: none;

  &:after {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    background: #FFFFFF;
    @include Position(1, 5, 50%, -5px);
    transform: translateX(-50%) rotate(135deg);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
  }

  &:before {
    content: '';
    display: inline-block;
    //width: 10px;
    height: 10px;
    background: #FFFFFF;
    width: 80%;
    border-radius: 12px;
    @include Position(1, 5, 50%, 0);
    transform: translateX(-50%);
    z-index: 2;
  }

  img {
    width: 130px;
    height: 130px;
    margin-bottom: 6px;
    vertical-align: middle;
  }

  .desc {
    font-size: 14px;
    color: #2D2B33;
    line-height: 20px;
    text-align: center;
  }
}
</style>
